import { gql } from 'apollo-angular';

export const orderPollingQuery = gql`
  query Order_polling($initial: Boolean!, $lastUpdatedOn: String) {
    order_polling(initial: $initial, last_updated_on: $lastUpdatedOn)
  }
`;

export const getOrderById = gql`
  query Get_order_json($id: String!) {
    get_order_json(id: $id)
  }
`;

export const LIST_ORDER_OPERATION_LOGS = gql`
  query Query($orderId: String!) {
    list_order_operation_log_json(order_id: $orderId)
  }
`;
export const listOrders = gql`
  query List_order($limit: Int, $page: Int, $orderBy: [String], $start_date: String, $end_date: String, $invoice: Int, $kot_number: Int, $order_status: String, $is_advance: Boolean, $source: String, $order_type: String, $customer_name: String, $customer_number: String) {
    list_order_json(limit: $limit, page: $page, order_by: $orderBy, start_date: $start_date, end_date: $end_date, invoice: $invoice, kot_number: $kot_number, order_status: $order_status, is_advance: $is_advance, source: $source, order_type: $order_type, customer_name: $customer_name, customer_number: $customer_number)
  }
`;

export const LIST_CALL_CANTER_ORDERS = gql`
  query List_order($limit: Int, $page: Int, $orderBy: [String], $start_date: String, $end_date: String, $invoice: Int, $kot_number: Int, $order_status: String, $branch_id: String, $aggregator_order_id: String) {
    list_order_json(limit: $limit, page: $page, order_by: $orderBy, start_date: $start_date, end_date: $end_date, invoice: $invoice, kot_number: $kot_number, order_status: $order_status, branch_id: $branch_id, aggregator_order_id: $aggregator_order_id)
  }
`;

export const LIST_ORDERS_BY_IDS = gql`
  query Query($orderIds: [String!]!) {
    list_order_by_ids(order_ids: $orderIds)
  }
`;

export const CHECK_ORDER_CHECKSUM = gql`
  query Query($orderId: String!, $updateUuid: String!) {
    check_order_checksum(order_id: $orderId, update_uuid: $updateUuid)
  }
`;

export const INITIATE_PAYMENT = gql`
  query Query($paymentInfo: PaymentData!) {
    initiate_payment_integration(paymentInfo: $paymentInfo)
  }
`;

export const GENERATE_INVOICE_NUMBER = gql`
  mutation Mutation($orderId: String!, $updateUuid: String!) {
    generate_invoice_number(order_id: $orderId, update_uuid: $updateUuid) {
      invoice_number
      invoice_prefix
      update_uuid
    }
  }
`;

export const INITIATE_ORDER_COMMENT_NOTIFICATION = gql`
  query Query($orderId: String!, $comment: String!) {
    initiate_order_comment_notification(order_id: $orderId, comment: $comment)
  }
`;

export const GET_ORDER_CREDIT_USERS = gql`
  query Query {
    get_order_credit_users
  }
`;

export const GET_CREDIT_ORDERS = gql`
  query Query($customerId: ID!) {
    get_user_credit_orders(customer_id: $customerId)
  }
`;


export const GET_ORDER_COMPLAINTS = gql`
  query GetOrderComplaint($orderId: String!) {
    list_order_complaint {
      id
      order_id(equal: $orderId)
      description
      complaint_status
      created_on
      complaint_type
    }
  }
`;

export const CREATE_COMPLAINT = gql`
  mutation CreateComplaint(
    $order_id: UUID!
    $complaint_type: String!
    $complaint_status: ComplaintStatus
    $description: String
    $resolution_details: String
  ) {
    create_order_complaint(
      row: {
        order_id: $order_id
        complaint_type: $complaint_type
        complaint_status: $complaint_status
        description: $description
        resolution_details: $resolution_details
      }
    ) {
      id
      order_id
      complaint_type
      complaint_status
      description
      resolution_details
      created_on
    }
  }
`;


export const UPDATE_COMPLAINT_STATUS = gql`
  mutation UpdateComplaintStatus($id: UUID!, $change: OrderComplaintInput!) {
    update_order_complaint(id: $id, change: $change) {
      id
      complaint_status
    }
  }
`;

export const DELETE_COMPLAINT = gql`
  mutation DeleteComplaint($id: UUID!) {
    delete_order_complaint(id: $id) {
      id
    }
  }
`;

export const sendEBillWhatsApp = gql`
  query Get_send_ebill_whatsapp($order_id: String!) {
    send_ebill_whatsapp(order_id: $order_id)
  }
`;
